export default "__VITE_ASSET__b8801907__"